@if (loading()) {
  <aux-table-skeleton />
} @else {
  <div class="px-7 py-7">
    <aux-table-panel>
      <div
        class="flex items-center gap-4 bg-[#FFCA80] p-4"
        [class.hidden]="currencyToggle() === 'contracted'"
      >
        <div
          class="size-[14px] rounded-full"
          data-pendo-tooltip-container="journal-entries-numbers-converted-to-us-dollar"
        ></div>
        <div class="font-medium">Journal Entry numbers converted to US Dollar ($).</div>
      </div>
      <div class="flex items-start justify-between p-4">
        <div class="flex flex-col items-start self-start">
          <div class="whitespace-nowrap text-[16px] font-bold leading-[20px]">Journal Entries</div>
          <ng-select
            class="w-64 self-start"
            [multiple]="false"
            [clearable]="false"
            [(ngModel)]="selectedMonth"
          >
            @for (month of monthOptions(); track month.value) {
              <ng-option [value]="month.value">
                {{ month.label }}
              </ng-option>
            }
          </ng-select>
          @if (flags().isHowItWorksVisible) {
            <button
              class="btn--hyperlink cursor-pointer p-0 leading-[20px]"
              (click)="openHowItWorksModal()"
            >
              How it works
            </button>
          }
        </div>
        <div class="flex flex-row-reverse flex-wrap items-center gap-4">
          <aux-button
            variant="secondary"
            icon="FileExport"
            label="Export"
            [onClick]="onExport.bind(this)"
            [attr.data-pendo-id]="'journal-entries-excel-export-button'"
          />

          <aux-button
            variant="secondary"
            icon="Settings"
            label="Manage Accounts"
            (clickEmit)="openManageBalanceSheetsAccountsModal()"
            [disabled]="!permissions().manageBalanceSheetsAccounts"
            [auxTooltip]="manageBalanceSheetsAccountsPermissionTooltip()"
          />

          <aux-checkbox
            class="text-sm"
            id="hide-rows-with-no-debit-or-credit"
            [checked]="hideRowsCheckBox()"
            (customChange)="hideRowsCheckBox.set($event)"
          >
            Hide Rows with No Debit/Credit
          </aux-checkbox>

          @if (showCurrencyToggle()) {
            <div class="ml-[100px] flex items-center gap-2">
              <aux-exchange-link class="[&_.exchange-link]:p-0" />
              <div class="flex items-center gap-2">
                <div>USD</div>
                <aux-toggle
                  [value]="currencyToggle() === 'contracted'"
                  (change)="onCurrencyToggleChange($event ? 'contracted' : 'usd')"
                />
                <div>Vendor Contract Currency</div>
              </div>
            </div>
          }
        </div>
      </div>
      <ag-grid-angular
        domLayout="autoHeight"
        class="new-flat-theme w-full tabular-nums"
        [gridOptions]="gridOptions()"
        [rowData]="gridData()"
        (gridReady)="onGridReady($event)"
        auxStickyGrid
      />
    </aux-table-panel>
  </div>
}
